import { Attribute, MetaData } from '..';

export class AttributeDto {
    constructor(public metadata: MetaData, public results: Attribute[]) {}
}
